import { PrimaryButton } from "components/Buttons/PrimaryButton";
import { Input } from "components/Inputs/Input";
import Row from "components/Row";
import React, { useState } from "react";
import { forgotPassword } from "../firebase";
import { AuthCardSubTitle, AuthCardTitle, LinkContainer } from "../styled";

export default function ForgotPasswordPage({ history }) {
  const [form, setForm] = useState({
    email: ""
  });

  const handleInput = event => {
    setForm({
      ...form,
      [event.target.name]: event.target.value
    });
  };

  function submit(e) {
    e.preventDefault();
    forgotPassword(form.email);
  }

  return (
    <React.Fragment>
      <AuthCardTitle>Forgot Password</AuthCardTitle>
      <AuthCardSubTitle>
        Enter registered email to send password reset link.
      </AuthCardSubTitle>
      <form onSubmit={submit}>
        <Input
          required
          type="email"
          id="outlined-email"
          label="Email"
          name="email"
          onChange={handleInput}
          margin="normal"
        />

        <LinkContainer>
          <span onClick={() => history.push("/login")}>Back to Login</span>
        </LinkContainer>
        <Row justify="space-between">
          <PrimaryButton type="submit">RESET PASSWORD</PrimaryButton>
        </Row>
      </form>
    </React.Fragment>
  );
}
